import { result, isUndefined, has } from 'lodash';
import { authenRocketChat, setChatID, logInRealtimeAPI } from '../helpers'
export const getSelector = (pathFromState) => (state) => result(state, pathFromState, null);

export const getRoomHistory = () => {
    const item = localStorage.getItem('features/recent-list')
    return (item !== null) ? JSON.parse(item).reverse() : []
}

export const validateEmail = (email) => {
    const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const charectorLength = (input) => {

    if (!isUndefined(input)) {
        let max_length = 15;
        let this_length = max_length - input.toString().length;
        if (this_length < 0) {
            let sub = input.substr(0, 15);
            let res = `${sub}...`
            return res;
        } else {
            console.log('ตัวอักษร', this_length)
        }
    }
}

export const isValidName = (name) => {
    // ? & : ' " % #  / \ $ ^ * `  > <
    // /^(?=.*[A-Za-z])(?=.*\d)[a-zA-Z0-9!@#$%^&*()~¥=_+}{":;'?/>.<,`\-\|\[\]]{6,50}$/
    let reg = /^(?!.*(?:&|:|'|"|%|#|\/|\\|\$|\^|\*|`|>|<|\?)).+/ ///^(?!(\?|&|:|'|"|%|#|\/|\\|\$|\^|\*|`|>|<)$).+/   ///^[\u4e00-\u9fa5ก-๙a-zA-Z0-9!+~@฿()={}|;.,_-]{1,100}$/
    // let reg = /^[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]|[ก-๙a-zA-Z0-9_-]{1,100}$/
    return reg.test(name)
}

export const validateMobileNation = mobile => {
    let m = mobile.split(' ');
    if (m.length > 0) {
        if ('+66' === m[0]) {
            if (m.join('').length >= 12) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return false;
    }
};

export const uploadImageValidate = (type, size) => {
    if (type.search("image/") >= 0) {
        let s = size.split(" ");
        if (s.length > 1) {
            if (parseInt(s[0]) <= 2048) {
                return true;
            }
        }
    } else {
        return false;
    }
};

export function randomNum() {
    let length = 32;
    let result = "";
    let characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    let i;
    for (i = 0; i < length; i++)
        result += characters.charAt(Math.floor(Math.random() * charactersLength));

    // setOTPState(result);
    return result;
}

export const authen = async () => {
    const token = localStorage.getItem('vtoken')

    if (token !== null) {
        const vtoken = await authenRocketChat(token)

        if (has(vtoken, 'chatUserID')) {
            setChatID(vtoken)
            setTimeout(() => {
                //    const set = JSON.parse(localStorage.getItem('setChatID'))

                // event setChatID = chatUserID
                //  connectSetChatID(set.chatUserID)
                const auth = JSON.parse(localStorage.getItem('chatUserToken'))
                logInRealtimeAPI(auth.chatUserToken)
                // const auth = JSON.parse(localStorage.getItem('chatUserToken'))
                // realtimeAPI.loginWithAuthToken(auth.chatUserToken).subscribe(
                //     (authResult) => {
                //         console.log("authResult", authResult);
                //         if (authResult.msg === "result") {
                //             if (authResult.error === undefined) {

                //             } else {
                //               console.log("login fail handle here");
                //             }
                //         }
                //     },
                //     (error) => {
                //         console.log("login error (may be network)", error);
                //     }
                // )

            }, 100);
        }
    } else {

        setTimeout(async () => {
            const getToken = localStorage.getItem('vtoken')

            if (getToken !== null) {
                const rocketAuth = await authenRocketChat(getToken)

                if (has(rocketAuth, 'chatUserID')) {
                    setChatID(rocketAuth)
                    setTimeout(() => {
                        //   const setcID = JSON.parse(localStorage.getItem('setChatID'))

                        // event setChatID = chatUserID
                        //  connectSetChatID(setcID.chatUserID)
                        const auth = JSON.parse(localStorage.getItem('chatUserToken'))
                        logInRealtimeAPI(auth.chatUserToken)
                        // const auth = JSON.parse(localStorage.getItem('chatUserToken'))
                        // realtimeAPI.loginWithAuthToken(auth.chatUserToken).subscribe(
                        //     (authResult) => {
                        //         console.log("authResult", authResult);
                        //         if (authResult.msg === "result") {
                        //             if (authResult.error === undefined) {

                        //             } else {
                        //             console.log("login fail handle here");
                        //             }
                        //         }
                        //     },
                        //     (error) => {
                        //         console.log("login error (may be network)", error);
                        //     }
                        // )

                    }, 100);
                }
            }
        }, 600);


    }
}
